import {
  type CarListApiData,
  TireLoadIndex,
  TireLoadIndexLabels,
  TireSpeedIndex,
  TireSpeedIndexLabels,
  type UserGroupFleetViewCarsListApiData
} from '@navio/nsdk';
import { filterUnitFor, type SharedQuery } from 'noddi-ui-web';

type CarQuery = NonNullable<CarListApiData['query']>;
type FleetQuery = NonNullable<UserGroupFleetViewCarsListApiData['query']>;
const unit = filterUnitFor<SharedQuery<CarQuery, FleetQuery>>();

const isListedSpeed = (value: TireSpeedIndex): value is Exclude<TireSpeedIndex, 'UNKNOWN'> =>
  value !== TireSpeedIndex.UNKNOWN;

const speedIndexOptions = (Object.entries(TireSpeedIndex) as [keyof typeof TireSpeedIndex, TireSpeedIndex][])
  .filter((entry): entry is [Exclude<keyof typeof TireSpeedIndex, 'UNKNOWN'>, Exclude<TireSpeedIndex, 'UNKNOWN'>] =>
    isListedSpeed(entry[1])
  )
  .map(([key, value]) => ({
    value,
    label: `${value} (${TireSpeedIndexLabels[key]} km/h)`
  }));

const loadIndexOptions = (Object.values(TireLoadIndex) as Array<string | TireLoadIndex>)
  .filter((value): value is TireLoadIndex => typeof value === 'number')
  .map((value) => ({
    value,
    label: `${value} (${TireLoadIndexLabels[value]} kg)`
  }));

export const tireIndexFilters = [
  unit.boolean('hasSpeedIndex', {
    title: 'Has speed index',
    description: 'The car shows a tire speed index.'
  }),
  unit.boolean('hasLoadIndex', {
    title: 'Has load index',
    description: 'The car shows a tire load index.'
  }),
  unit.multiSelect('speedIndexes', {
    title: 'Speed index',
    description: 'Cars whose highest speed is one of these indexes.',
    options: speedIndexOptions,
    exclude: false
  }),
  unit.multiSelect('loadIndexes', {
    title: 'Load index',
    description: 'Cars whose highest load is one of these indexes.',
    options: loadIndexOptions,
    exclude: false
  })
];
